<template>
  <article>
    <div id="PageTitle">
	<div class="container">
		<h1 class="page-header">{{title}}</h1>
		<div id="Breadcrumbs">
    <a href="/">home</a> &gt; 
	
		<a href="/whats-on/" class="breadcrumb-1">What's On</a>

    <template v-if='$route != "whatsonsearch"'>&gt; <span class="breadcrumb-1">{{title}}</span></template>
    </div>
      </div>
    </div>
     <div id="Pills">
      <div class="container">
        <ul class="nav nav-pills row">
            <router-link tag='li' exact-active-class="active" :to="{name: 'whatsonsearch', query: { categories: 'Exhibition,Display'}}"><a>Exhibitions and Displays</a></router-link>
            <router-link tag='li' exact-active-class="active" :to="{name: 'whatsonsearch', query: { categories: 'Show'}}"><a>Perpetual Guardian Planetarium</a></router-link>
            <router-link tag='li' exact-active-class="active" :to="{name: 'whatsonsearch', query: { categories: 'Event'}}"><a>Programmes and Events</a></router-link>
            <router-link tag='li' exact-active-class="active" :to="{name: 'whatsonsearch', query: { categories: 'Gallery'}}"><a>Galleries</a></router-link>
            <router-link tag='li' exact-active-class="active" :to="{name: 'whatsonsearch', query: { categories: 'GuidedTour'}}"><a>Guided Tours</a></router-link>
        </ul>
      </div>
    </div>
	<section id="Content">
		<div class="container">
			<div id="app">
        <router-view @updateHead='updateHead'></router-view>
			</div>
		</div>
	</section>
</article>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import WhatsOnSearch from './WhatsOnSearch';

const server = 'https://otagomuseum.nz';
//const server = 'http://acharlton15:2078';

export default {
  data() {
    return {
      categoryMap: {
        'Exhibition': {name: 'Exhibitions', class: 'cs-cerulean'},
        'Display': {name: 'Displays', class: 'cs-teal-displays'},
        'Gallery': {name: 'Galleries', class: 'cs-yellow-galleries'},
        'Show': {name: 'Planetarium Shows', class: 'cs-red-pgp'},
        'Event': {name: 'Programmes and Events', class: 'cs-navy-events'},
        'Tour': {name: 'Tours', class: 'cs-green-tours'}
      },
      selectedCategories: ['Show', 'Event'],
      categories: {},
      title: "What's On"
    }
  },
  methods: {
    updateHead(event) {
      this.title = event.title;
      document.title = event.title + " | Tūhura Otago Museum";
    }
  },
  watch: {
    '$route'() {
      if (this.$route.name == 'whatsonsearch') {
        this.title = "What's On";
        document.title = "What's On"  + " | Tūhura Otago Museum";
      }
    }
  },
  created() {

  },
  components: {
      'whats-on-search': WhatsOnSearch
  }
}
</script>

<style lang="less">
</style>





